<template>
  <div class="h-full">
    <section
      class="flex flex-col items-center justify-center px-4 text-center text-white cover py-16"
    >
      <p class="mb-10 -mt-5 text-4xl">Create Account</p>

      <form @submit.prevent>
        <div class="flex flex-col items-center max-w-lg">

           <base-avatar
            v-model="avatar_id"
            v-validate="'required'"
            name="avatar"
            :message="errors.first('avatar')"
          />
          <div class="flex flex-wrap">
            <base-input
              v-model="name"
              v-validate="'required|max: 255'"
              name="name"
              class="flex-grow w-40 m-2"
              inputClass="rounded-md bg-gray-500 text-white"
              placeholder="Name"
              :message="errors.first('name')"
            />

            <base-input
              v-model="username"
              v-validate="'required|min:3|max:255 '"
              name="username"
              class="flex-grow w-40 m-2"
              inputClass="rounded-md bg-gray-500 text-white"
              placeholder="Username"
              :message="errors.first('username')"
            />

            <base-input
              v-model="email"
              v-validate="'required|email'"
              name="email"
              class="flex-grow w-40 m-2"
              inputClass="rounded-md bg-gray-500 text-white"
              placeholder="Email"
              :message="errors.first('email')"
            />

            <base-input
              v-model="phone"
              v-validate="'required'"
              v-mask="'(###) ###-####'"
              name="phone"
              class="flex-grow w-40 m-2"
              inputClass="rounded-md bg-gray-500 text-white"
              placeholder="Phone"
              :message="errors.first('phone')"
            />

            <base-input
              v-model="password"
              v-validate="'required|min:8|max:255'"
              name="password"
              class="flex-grow w-40 m-2"
              inputClass="rounded-md bg-gray-500 text-white"
              placeholder="Password"
              type="password"
              :message="errors.first('password')"
            />
          </div>

          <button
            class="mt-12 rounded-md btn"
            :disabled="isLoading"
            @click="handleRegister"
          >
            Register Account
          </button>

          <template v-if="isSnapchatAuth">
            <div class="flex items-center justify-center w-full mx-auto my-5">
              <span>Or</span>
            </div>
            <div class="flex items-center justify-center w-full mx-auto">
              <button
                class="flex items-center justify-center max-w-xs py-2 pl-4 pr-5 space-x-2 text-black w-70 bg-snapchat-500 hover:bg-yellow-400 rounded-3xl"
                @click="registerWithSnapchat"
                title="Register with Snapchat"
              >
                <img
                  src="/images/snapchat-logo.svg"
                  alt="snapchat logo"
                  width="32"
                  height="32"
                />
                <span class="font-semibold text-md">
                  Register with Snapchat
                </span>
              </button>
            </div>
          </template>
        </div>
      </form>
    </section>

    <base-footer />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AuthService from "@/services/AuthService";

export default {
  data() {
    return {
      isSnapchatAuth: false,
      name: "",
      username: "",
      email: "",
      phone: "",
      password: "",
      avatar_id: '',
      isLoading: false,
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),
    async handleRegister() {
      try {
        if (this.isLoading || !(await this.$validator.validateAll())) {
          return;
        }
        this.isLoading = true;


        await AuthService.register({
          name: this.name,
          username: this.username,
          email: this.email,
          phone: this.phone,
          password: this.password,
          password_confirmation: this.password,
          avatar_id: this.avatar_id,
        });

        await this.login({
          email: this.email,
          password: this.password,
        });

        this.$router.replace({ name: "stations" });
      } catch (e) {
        this.$setErrorsFromLaravel(e.response.data);
      } finally {
        this.isLoading = false;
      }
    },
    registerWithSnapchat() {
      window.location.href = `${process.env.VUE_APP_SNAPCHAT_AUTH_URL}`;
    },
  },
};
</script>

<style scoped>
.cover {
  background-image: url("/images/background.jpg");
  height: calc(100% - 24px);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
